/*!
 * jQuery unSlick
 * Copyright (c) ATOM
 */

import 'slick-carousel';

(function($) {
  
$.fn.slickCustom = function(options) {

  var settings = $.extend({

    onInit: function () {},
    beforeInit: function() {},
    min: 0,
    max: 768,
    slickSettings: {}
        
  }, options);  
    
  return this.each(function() {

    var $this = $(this),        
        timer;

    var setSlick = function() {
      var windowWidth = $(window).width();

      if (windowWidth >= settings.min && 
          windowWidth < settings.max &&
          !$this.hasClass('slick-initialized')) {

          setTimeout(function() {
            $.when( beforeInit() ).done(function() {
              $this.on('init', settings.onInit);

              $this.slick(settings.slickSettings);
            });
          }, 100);

          
      } else if ( (windowWidth < settings.min || 
                 windowWidth >= settings.max) &&
                 $this.hasClass('slick-initialized')) {

          

          setTimeout(function() {
            $this.slick('unslick');
          }, 100);
      }
    };

    var refreshSlick = function() {
      if(timer) {
        clearTimeout(timer);          
      }
      timer = setTimeout(setSlick, 100);
    };

    $(window).resize(function() {
      refreshSlick();      
    });


    function beforeInit() {
      settings.beforeInit();   
    }

    setSlick();

  });

};

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/jquery.plugins/jquery.slickCustom.js